<template>
	<div class="columns is-multiline">
		<div class="column is-full">
			<product-review
				:summary_prop="summary"
				@update-review-section="updateReviewSection"
				:product_id_prop="product_id_prop"
				:review_link_prop="review_link_prop"
				:placeholder_prop="placeholder_prop"></product-review>
		</div>
		<div class="column is-full">
			<review-viewer
				ref="reviewViewer"
				@update-review-section="updateReviewSection"
				:is_logged_in_prop="isLoggedIn"
				:product_id_prop="product_id_prop"
				:reviews_prop="reviews"
				:review_link_api_prop="review_link_api_prop"
				:review_link_prop="review_link_prop"
				:placeholder_prop="placeholder_prop"></review-viewer>
		</div>
	</div>
</template>
<style scoped></style>
<script>
	import ProductReview from "./ProductReview.vue";
	import ReviewViewer from "./ReviewViewer.vue";

	export default {
		props: {
			product_id_prop: Number,
			review_link_prop: String,
			review_link_api_prop: String,
			placeholder_prop: String,
			review_link_prop: String,
			is_logged_in_prop: Boolean,
		},
		components: { ProductReview, ReviewViewer },
		data() {
			return {
				reviews: [],
				summary: {},
			};
		},
		computed: {
			isLoggedIn() {
				if (
					typeof JSON.parse(window.sessionStorage.getItem("logged_in"))
						.value != "undefined"
				) {
					return JSON.parse(window.sessionStorage.getItem("logged_in"))
						.value;
				} else {
					return false;
				}
			},
		},
		mounted() {
			this.fetchReviews();
		},
		methods: {
			updateReviewSection() {
				this.fetchReviews();
			},
			fetchReviews() {
				let _this = this;
				axios
					.get(_this.$props.review_link_api_prop)
					.then(function (res) {
						_this.reviews = res.data.reviews;
						_this.summary = res.data.summary;
					})
					.catch(function (error) {
						console.log(error);
					})
					.then(function (res) {});
			},
		},
	};
</script>
